module.exports = __webpack_public_path__ + "img/laurel-top-angle.735e03c0.png";